import { Component } from '@angular/core';

@Component({
  selector: 'avano-required-icon',
  templateUrl: './avano-required-icon.component.html',
  styleUrls: ['./avano-required-icon.component.scss']
})
export class AvanoRequiredIconComponent {}
